module.exports = __webpack_public_path__ + "static/media/phone.7e329f0e.svg";